var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container",
    clipPath: "url(#clip0_601_13975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4969 3.95741C16.6781 4.02271 17.7857 4.55226 18.5783 5.43065C19.3708 6.30904 19.7841 7.46508 19.7279 8.64683C19.7279 11.4076 17.3446 13.1035 15.0574 15.1373C12.7999 17.153 11.5839 18.2548 11.1903 18.5092C10.7616 18.2315 9.26437 16.8708 7.32317 15.1373C5.02609 13.0954 2.65262 11.3834 2.65262 8.64683C2.59652 7.46508 3.00976 6.30904 3.8023 5.43065C4.59484 4.55226 5.70243 4.02271 6.88371 3.95741C7.53809 3.93758 8.18643 4.08788 8.76533 4.39364C9.34423 4.69939 9.83389 5.15013 10.1864 5.70179C10.9413 6.75776 11.0672 7.2862 11.193 7.2862C11.3188 7.2862 11.4428 6.75776 12.1905 5.69909C12.5411 5.14488 13.0309 4.69236 13.6111 4.38673C14.1913 4.0811 14.8415 3.93306 15.4969 3.95741ZM15.4969 2.16001C14.6808 2.13388 13.8693 2.29219 13.1229 2.62315C12.3765 2.95412 11.7143 3.4492 11.1858 4.07154C10.6577 3.45101 9.99691 2.95707 9.25228 2.62621C8.50765 2.29535 7.69819 2.13602 6.88371 2.16001C5.22549 2.22485 3.66041 2.94366 2.53071 4.15925C1.401 5.37485 0.798599 6.98831 0.855222 8.64683C0.855222 11.8911 3.14691 13.8836 5.36221 15.8095C5.61654 16.0306 5.87357 16.2534 6.1288 16.4808L7.05177 17.3058C8.05835 18.2636 9.11362 19.1689 10.2134 20.0181C10.5044 20.2065 10.8436 20.3067 11.1903 20.3067C11.5369 20.3067 11.8762 20.2065 12.1672 20.0181C13.302 19.143 14.3897 18.2085 15.4259 17.2186L16.2545 16.4781C16.5178 16.2445 16.7847 16.0117 17.0498 15.7825C19.1474 13.9626 21.5253 11.9001 21.5253 8.64683C21.582 6.98831 20.9796 5.37485 19.8499 4.15925C18.7202 2.94366 17.1551 2.22485 15.4969 2.16001Z",
    fill: "#C0C0C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_13975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5688,
    height: 21.5688,
    fill: "white",
    transform: "translate(0.405273 0.449219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLike);
export default __webpack_public_path__ + "static/media/white_like.7e20f994e62f468030f9f94b3f834ef8.svg";
export { ForwardRef as ReactComponent };